var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9997 21.9996V13.942C21.9997 9.98204 21.1472 6.95703 16.5272 6.95703C14.2997 6.95703 12.8147 8.16703 12.2097 9.32204H12.1547V7.31453H7.78223V21.9996H12.3472V14.712C12.3472 12.787 12.7047 10.9445 15.0697 10.9445C17.4072 10.9445 17.4347 13.117 17.4347 14.822V21.9721H21.9997V21.9996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.357422 7.31543H4.92243V22.0004H0.357422V7.31543Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64 0C1.1825 0 0 1.1825 0 2.64C0 4.09751 1.1825 5.30751 2.64 5.30751C4.09751 5.30751 5.28001 4.09751 5.28001 2.64C5.28001 1.1825 4.09751 0 2.64 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootIcon2);
export default __webpack_public_path__ + "static/media/foot_icon2.a93547592f8be2f4822e08af32027bc5.svg";
export { ForwardRef as ReactComponent };